const DOWNLOAD_FILE_TYPES = {
  docxEmp: 'docxEmp',
  docx: 'docx',
  pdf: 'pdf',
};

export default DOWNLOAD_FILE_TYPES;
